const SHANGHAI_OFFSET_MS = 8 * 60 * 60 * 1000;
const WEDNESDAY = 3;
const SCHEDULE_HOUR = 17;

export function latestScheduledRefresh(now = new Date()): Date {
  const shanghaiNow = new Date(now.getTime() + SHANGHAI_OFFSET_MS);
  const daysSinceWednesday = (shanghaiNow.getUTCDay() - WEDNESDAY + 7) % 7;
  const scheduledLocalTime = Date.UTC(
    shanghaiNow.getUTCFullYear(),
    shanghaiNow.getUTCMonth(),
    shanghaiNow.getUTCDate() - daysSinceWednesday,
    SCHEDULE_HOUR,
  );
  let scheduledUtc = scheduledLocalTime - SHANGHAI_OFFSET_MS;
  if (scheduledUtc > now.getTime()) scheduledUtc -= 7 * 24 * 60 * 60 * 1000;
  return new Date(scheduledUtc);
}

export function isSnapshotStale(generatedAt: string, now = new Date()): boolean {
  const generatedTime = Date.parse(generatedAt);
  if (!Number.isFinite(generatedTime)) return true;
  return generatedTime < latestScheduledRefresh(now).getTime();
}

export function formatSnapshotTimestamp(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '无效时间';
  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')} ${part('hour')}:${part('minute')}`;
}
